import React, { useEffect, useState } from "react";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import DropDownTax from "../../../../styled-components/dropdown/dropdownTax";
import * as Style from "./styles/tax-information";
import { InputGroup } from "../../../../styled-components/input/styles/input";
import IconInputTax from "../../../../styled-components/input/icon-input-tax";
import { Button } from "../../../../styled-components/button";
import { Text } from "../../../../styled-components/text";
import TaxCredits from "../tax-credits/tax-credits";
import {
  deductionsList,
  taxFillingElectionList,
  citiesByState,
  taxSpecificStatesList,
} from "../data/data";
import { MODULE_API } from "../../../../../apis";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
import { SocialSecurityHardCodeFields } from "../../../../../newComponents/SocialSecurity/components/SocialSecurityHardCodeFields";
import {
  calculateCapitalGainsTax,
  calculateProjectionSeries,
  calculateTotalTax,
} from "../../../../../helpers/taxCalculations";
import taxData from "../../../../../helpers/taxData2025.json";
import {
  InputNumber,
  DatePicker,
  Radio,
  Checkbox,
  Select,
  Input,
  Collapse,
} from "antd";
import moment from "moment";
import { TaxProjectionOverview } from "./TaxProjectionOverview";
import TAX_AND_INFLATION_API from "../../../../../apis/tax_and_inflation.api";
import NewLoader from "../../../../styled-components/loader/NewLoader";
const { Panel } = Collapse;
function TaxInformation({ handleTaxInflationObject, nextForm, data, taxInfo }) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [yearlyDataReport, setYearlyDataReport] = useState(null);
  const [taxInformationData, setTaxInformationData] = useState(null);
  const [creditData, setCreditData] = useState([]);
  const [carryForwardCredits, setCarryForwardCredits] = useState([]);

  const getTaxInflationDetails = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchTaxInflationDetails();
      if (data && data.data) {
        //inflation details
        // console.log("response==>", data.data);
        const taxInfoData = data.data[0];
        if (taxInfoData) {
          setTaxInformationData({
            "State Taxation":
              taxInfoData && taxInfoData.state ? taxInfoData.state : "",
            "City of Residence":
              taxInfoData && taxInfoData.city ? taxInfoData.city : "",
            "Tax Filling Election":
              taxInfoData && taxInfoData.taxFillingElection
                ? taxInfoData.taxFillingElection
                : "",
            Deductions:
              taxInfoData && taxInfoData.deductions
                ? taxInfoData.deductions
                : "",
            "State Tax Effective Rate":
              taxInfoData && taxInfoData.stateTaxRate
                ? taxInfoData.stateTaxRate
                : "",
            "Federal Tax Rate":
              taxInfoData && taxInfoData.federalTaxRate
                ? taxInfoData.federalTaxRate
                : "",
            "Total Tax Rate":
              taxInfoData && taxInfoData.totalTaxRate
                ? taxInfoData.totalTaxRate
                : "",
            "Federal Collectible Tax Rate":
              taxInfoData && taxInfoData.federalCollectibleTaxRate
                ? taxInfoData.federalCollectibleTaxRate
                : "",
            "Medical and Dental Expenses":
              taxInfoData && taxInfoData.medicalAndDentalExpenses
                ? taxInfoData.medicalAndDentalExpenses
                : "",
            "State and Local Taxes (SALT)":
              taxInfoData && taxInfoData.stateAndLocalTaxesSalt
                ? taxInfoData.stateAndLocalTaxesSalt
                : "",
            "Home Mortgage Interest":
              taxInfoData && taxInfoData.homeMortgageInterest
                ? taxInfoData.homeMortgageInterest
                : "",
            "Charitable Contributions":
              taxInfoData && taxInfoData.charitableContributions
                ? taxInfoData.charitableContributions
                : "",
            "Number of Dependents":
              taxInfoData && taxInfoData.noOfDependents
                ? taxInfoData.noOfDependents
                : "",
            ...taxInfoData,
          });
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching Tax Inflation Details", error);
    }
  };
  const getTaxCredit = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchTaxCreditList();
      if (data && data.data) {
        setCreditData(data.data.rows);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };
  const getCarryForward = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchCarryForward();
      if (data && data.data) {
        setCarryForwardCredits(data.data.rows);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };

  const handleInputChangeTax = (name, value) => {
    setYearlyDataReport({
      ...yearlyDataReport,
      [name]: value,
    });
  };

  const getIncomeTotalYearly = async () => {
    try {
      setLoading(true);
      const currentDate = moment();
      const startDate = currentDate
        .clone()
        .startOf("year")
        .format("YYYY-MM-DD");
      // const endDate = currentDate.clone().endOf("year").format("YYYY-MM-DD");
      const endDate = currentDate.clone().endOf("month").format("YYYY-MM-DD");
      let datares = await MODULE_API.fetchIncomeSum(startDate, endDate);
      if (datares && datares.data) {
        const yearlyData = datares.data;
        let yearlyResponse = {
          ...datares.data,
          totalYearly: yearlyData
            ? (+yearlyData.Active || 0) + (+yearlyData.Passive || 0)
            : 0,
        };
        setYearlyDataReport(yearlyResponse);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const { styles } = defaultStyles;

  const handleTaxInformationChange = (name, value) => {
    setTaxInformationData({
      ...taxInformationData,
      [name]: value,
    });
  };

  const handleTaxInformation = (obj) => {
    // console.log("obj", obj);
    const { name, value } = obj;

    setTaxInformationData({
      ...taxInformationData,
      [name]: value,
    });
  };

  const nextComponent = {
    name: "taxCredits",
    title: "Tax Credits",
    unique: "Other Tax Credit",
    isMulti: true,
    component: TaxCredits,
    taxCredits: {},
  };

  const handleSaveTaxInformation = async () => {
    try {
      setLoading(true);

      let payload = {
        state:
          taxInformationData && taxInformationData["State Taxation"]
            ? taxInformationData["State Taxation"]
            : "",
        city:
          taxInformationData && taxInformationData["City of Residence"]
            ? taxInformationData["City of Residence"]
            : "",
        taxFillingElection:
          taxInformationData && taxInformationData["Tax Filling Election"]
            ? taxInformationData["Tax Filling Election"]
            : "",
        deductions:
          taxInformationData && taxInformationData["Deductions"]
            ? taxInformationData["Deductions"]
            : "",
        stateTaxRate:
          taxInformationData && taxInformationData["State Tax Effective Rate"]
            ? Number(taxInformationData["State Tax Effective Rate"])
            : 0,
        federalTaxRate:
          taxInformationData &&
          taxInformationData.taxInformation &&
          taxInformationData.taxInformation.data &&
          taxInformationData.taxInformation.data[0] &&
          taxInformationData.taxInformation.data[0]["Federal Tax Rate"]
            ? Number(
                taxInformationData.taxInformation.data[0]["Federal Tax Rate"]
              )
            : 0,
        totalTaxRate:
          taxInformationData && taxInformationData["Total Tax Rate"]
            ? Number(taxInformationData["Total Tax Rate"])
            : 0,
        federalCollectibleTaxRate:
          taxInformationData &&
          taxInformationData["Federal Collectible Tax Rate"]
            ? Number(taxInformationData["Federal Collectible Tax Rate"])
            : 0,
        effectiveTaxRate:
          result && result.effectiveRate ? Number(result.effectiveRate) : 0,
        marginalTaxRate:
          result && result.marginalRate ? Number(result.marginalRate) : 0,
        totalTaxLiability:
          result && result.totalTaxLiability
            ? Number(result.totalTaxLiability)
            : 0,
        medicalAndDentalExpenses:
          taxInformationData &&
          taxInformationData["Medical and Dental Expenses"]
            ? Number(taxInformationData["Medical and Dental Expenses"])
            : 0,
        stateAndLocalTaxesSalt:
          taxInformationData &&
          taxInformationData["State and Local Taxes (SALT)"]
            ? Number(taxInformationData["State and Local Taxes (SALT)"])
            : 0,
        homeMortgageInterest:
          taxInformationData && taxInformationData["Home Mortgage Interest"]
            ? Number(taxInformationData["Home Mortgage Interest"])
            : 0,
        charitableContributions:
          taxInformationData && taxInformationData["Charitable Contributions"]
            ? Number(taxInformationData["Charitable Contributions"])
            : 0,
        noOfDependents:
          taxInformationData && taxInformationData["Number of Dependents"]
            ? Number(taxInformationData["Number of Dependents"])
            : 0,
        // --- Income & AGI Adjustments ---
        grossIncome:
          taxInformationData && taxInformationData.grossIncome
            ? Number(taxInformationData.grossIncome)
            : 0,
        earnedIncome:
          taxInformationData && taxInformationData.earnedIncome
            ? Number(taxInformationData.earnedIncome)
            : 0,
        hsaContributions:
          taxInformationData && taxInformationData.hsaContributions
            ? Number(taxInformationData.hsaContributions)
            : 0,
        studentLoan:
          taxInformationData && taxInformationData.studentLoan
            ? Number(taxInformationData.studentLoan)
            : 0,
        iraContribution:
          taxInformationData && taxInformationData.iraContribution
            ? Number(taxInformationData.iraContribution)
            : 0,
        educatorExpenses:
          taxInformationData && taxInformationData.educatorExpenses
            ? Number(taxInformationData.educatorExpenses)
            : 0,

        // --- Capital Gains / Losses ---
        shortTermGainsLoss:
          taxInformationData && taxInformationData.shortTermGainsLoss
            ? Number(taxInformationData.shortTermGainsLoss)
            : 0,
        longTermGainsLoss:
          taxInformationData && taxInformationData.longTermGainsLoss
            ? Number(taxInformationData.longTermGainsLoss)
            : 0,
        lossCarryforward:
          taxInformationData && taxInformationData.lossCarryforward
            ? Number(taxInformationData.lossCarryforward)
            : 0,

        // --- Federal Tax Credits ---
        careExpenses:
          taxInformationData && taxInformationData.careExpenses
            ? Number(taxInformationData.careExpenses)
            : 0,
        educationExpenses:
          taxInformationData && taxInformationData.educationExpenses
            ? Number(taxInformationData.educationExpenses)
            : 0,
        grossIncome:
          (taxInformationData && taxInformationData.earnedIncome) ||
          (taxInformationData && taxInformationData.AGI) ||
          result
            ? result.grossIncome
            : 0,

        // ...taxInformationData,
      };

      // If id exists, include it to update, else save new
      if (taxInformationData && taxInformationData.id) {
        payload.id = taxInformationData.id;
        await TAX_AND_INFLATION_API.updateTaxInflationDetails(payload);
      } else {
        await TAX_AND_INFLATION_API.saveTaxInflationDetails(payload);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error while saving/updating tax information:", error);
    }
  };

  const submitData = async () => {
    await handleSaveTaxInformation();
    handleTaxInflationObject(taxInformationData);
    nextForm(nextComponent);
  };

  const cityList =
    taxInformationData &&
    taxInformationData["State Taxation"] &&
    citiesByState[taxInformationData["State Taxation"]]
      ? citiesByState[taxInformationData["State Taxation"]].map((city) => ({
          name: city,
        }))
      : [];

  useEffect(() => {
    getIncomeTotalYearly();
    getTaxInflationDetails();
    getTaxCredit();
    getCarryForward();
  }, []);

  // useEffect(() => {
  //   const grossIncome = yearlyDataReport
  //     ? yearlyDataReport.totalYearly
  //     : (taxInformationData && taxInformationData["Gross Income"]) || 0;

  //   const generalInflationRate =
  //     taxInformationData && taxInformationData.generalInflationRate
  //       ? taxInformationData.generalInflationRate || 0
  //       : 0;

  //   const filingStatus =
  //     (taxInformationData && taxInformationData["Tax Filling Election"]) ||
  //     "single";
  //   const stateName =
  //     (taxInformationData && taxInformationData["State Taxation"]) ||
  //     "California";
  //   const deductions =
  //     (taxInformationData && taxInformationData["Deductions"]) || "Standard";

  //   // Prepare credits object with all required inputs
  //   const credits = {
  //     numChildrenUnder17:
  //       (taxInformationData && taxInformationData.numChildrenUnder17) || 0,
  //     contributionAmount:
  //       (taxInformationData && taxInformationData.retirementContribution) || 0,
  //     agi: (taxInformationData && taxInformationData.AGI) || grossIncome,
  //     magi:
  //       (taxInformationData && taxInformationData.MAGI) ||
  //       (taxInformationData && taxInformationData.AGI) ||
  //       grossIncome,
  //     improvementCost:
  //       (taxInformationData && taxInformationData.improvementCost) || 0,
  //     installationCost:
  //       (taxInformationData && taxInformationData.installationCost) || 0,
  //     careExpenses:
  //       (taxInformationData && taxInformationData.careExpenses) || 0,
  //     numDependents:
  //       (taxInformationData && taxInformationData.numDependents) || 0,
  //     adoptionExpenses:
  //       (taxInformationData && taxInformationData.adoptionExpenses) || 0,
  //     educationExpensesAOTC:
  //       (taxInformationData && taxInformationData.educationExpensesAOTC) || 0,
  //     educationExpensesLLC:
  //       (taxInformationData && taxInformationData.educationExpensesLLC) || 0,
  //     purchasePrice:
  //       (taxInformationData && taxInformationData.vehiclePurchasePrice) || 0,
  //     vehicleType:
  //       (taxInformationData && taxInformationData.vehicleType) || null, // 'new' or 'used'
  //     numChildren: (taxInformationData && taxInformationData.numChildren) || 0,
  //     earnedIncome:
  //       (taxInformationData && taxInformationData.earnedIncome) ||
  //       (taxInformationData && taxInformationData.AGI) ||
  //       grossIncome,
  //     investmentIncome:
  //       (taxInformationData && taxInformationData.investmentIncome) || 0,
  //     foreignTaxPaid:
  //       (taxInformationData && taxInformationData.foreignTaxPaid) || 0,
  //   };

  //   // Calculate current year tax
  //   const results = calculateTotalTax(
  //     grossIncome,
  //     filingStatus,
  //     stateName,
  //     credits
  //   );

  //   // Calculate 10-year projection
  //   const projectionResult = calculateProjectionSeries({
  //     grossIncome,
  //     filingStatus,
  //     stateName,
  //     credits,
  //     generalInflationRate:
  //       generalInflationRate && !isNaN(generalInflationRate)
  //         ? Number(generalInflationRate)
  //         : 0.03,
  //     years: 10,
  //   });

  //   setResult({ ...projectionResult, ...results }); // Combine projections and current year results
  // }, [taxInformationData, yearlyDataReport, data]);

  useEffect(() => {
    if (!taxInformationData && !yearlyDataReport) return;

    // === 1. Core Inputs ===
    const grossIncome = yearlyDataReport
      ? yearlyDataReport.totalYearly
      : (taxInformationData && taxInformationData.grossIncome) || (taxInformationData && taxInformationData["Gross Income"]) || 0;

    const filingStatus =
      (taxInformationData && taxInformationData["Tax Filling Election"]) ||
      "single";
    const stateName =
      (taxInformationData && taxInformationData["State Taxation"]) ||
      "California";
    const city =
      (taxInformationData && taxInformationData["City of Residence"]) ||
      "Other";

    const deductionType =
      (
        (taxInformationData && taxInformationData["Deductions"]) ||
        "Standard"
      ).toLowerCase() === "itemized"
        ? "itemized"
        : "standard";

    const generalInflationRate =
      taxInformationData && taxInformationData.generalInflationRate
        ? Number(taxInformationData.generalInflationRate) / 100
        : 0.03;

    // === 2. Above-the-Line Deductions ===
    const selfIncome =
      (taxInformationData &&
        taxInformationData.earnedIncome &&
        parseFloat(taxInformationData.earnedIncome)) ||
      0;
    const hsa =
      (taxInformationData &&
        taxInformationData.hsaContributions &&
        parseFloat(taxInformationData.hsaContributions)) ||
      0;
    const studentLoan =
      (taxInformationData &&
        taxInformationData.studentLoan &&
        parseFloat(taxInformationData.studentLoan)) ||
      0;
    const tradIra =
      (taxInformationData &&
        taxInformationData.iraContribution &&
        parseFloat(taxInformationData.iraContribution)) ||
      0;
    const educator =
      (taxInformationData &&
        taxInformationData.educatorExpenses &&
        parseFloat(taxInformationData.educatorExpenses)) ||
      0;


    // === 3. Capital Gains & Losses (Aggregate from form fields and table) ===
    const formST = (taxInformationData && parseFloat(taxInformationData.shortTermGainsLoss)) || 0;
    const formLT = (taxInformationData && parseFloat(taxInformationData.longTermGainsLoss)) || 0;
    const formCarry = (taxInformationData && parseFloat(taxInformationData.lossCarryforward)) || 0;

    let shortTermGains = formST > 0 ? formST : 0;
    let shortTermLosses = formST < 0 ? Math.abs(formST) : 0;
    let longTermGains = formLT > 0 ? formLT : 0;
    let longTermLosses = formLT < 0 ? Math.abs(formLT) : 0;
    let carryforwardLoss = formCarry;

    // carryForwardCredits &&
    //   carryForwardCredits.forEach((asset) => {
    //     if (!asset.enable || asset.deleted) return;

    //     const purchasePrice = parseFloat(asset.purchasePrice) || 0;
    //     const salePrice = parseFloat(asset.salePrice) || 0;
    //     const commission = parseFloat(asset.commissionAndFees) || 0;
    //     const purchaseDate = new Date(asset.purchaseDate);
    //     const saleDate = new Date(asset.saleDate);
    //     const holdingYears =
    //       (saleDate - purchaseDate) / (1000 * 60 * 60 * 24 * 365);
    //     const gainLoss = salePrice - purchasePrice - commission;

    //     if (gainLoss >= 0) {
    //       if (holdingYears > 1) longTermGains += gainLoss;
    //       else shortTermGains += gainLoss;
    //     } else {
    //       if (holdingYears > 1) longTermLosses += Math.abs(gainLoss);
    //       else shortTermLosses += Math.abs(gainLoss);
    //     }
    //   });

    const netShortTerm = shortTermGains - shortTermLosses;
    const netLongTerm = longTermGains - longTermLosses;
    const carryforward = carryforwardLoss;

    // === 4. Itemized Deductions ===
    const itemized =
      deductionType === "itemized"
        ? {
            medical:
              (taxInformationData &&
                parseFloat(
                  taxInformationData["Medical and Dental Expenses"]
                )) ||
              0,
            salt:
              (taxInformationData &&
                parseFloat(
                  taxInformationData["State and Local Taxes (SALT)"]
                )) ||
              0,
            mortgage:
              (taxInformationData &&
                parseFloat(taxInformationData["Home Mortgage Interest"])) ||
              0,
            charity:
              (taxInformationData &&
                parseFloat(taxInformationData["Charitable Contributions"])) ||
              0,
          }
        : {};

    // === 5. Credits Mapping (from creditData) ===
    let careExpenses =
      taxInformationData && taxInformationData.careExpenses
        ? Number(taxInformationData.careExpenses)
        : 0;
    let educationExpenses =
      taxInformationData && taxInformationData.educationExpenses
        ? Number(taxInformationData.educationExpenses)
        : 0;
    let numDependents =
      (taxInformationData && taxInformationData["Number of Dependents"]) || 0;
    const credits = {
      numChildrenUnder17: 0,
      contributionAmount: tradIra || 0,
      agi: (taxInformationData && taxInformationData.AGI) || grossIncome,
      magi:
        (taxInformationData && taxInformationData.MAGI) ||
        (taxInformationData && taxInformationData.AGI) ||
        grossIncome,
      improvementCost: 0,
      installationCost: 0,
      careExpenses: careExpenses,
      educationExpenses: educationExpenses,
      numDependents: numDependents,
      adoptionExpenses: 0,
      educationExpensesAOTC: 0,
      educationExpensesLLC: 0,
      purchasePrice: 0,
      vehicleType: null,
      numChildren: 0,
      earnedIncome:
        parseFloat(taxInformationData && taxInformationData.earnedIncome) ||
        parseFloat(taxInformationData && taxInformationData.AGI) ||
        grossIncome,
      investmentIncome:
        (taxInformationData && taxInformationData.investmentIncome) || 0,
      foreignTaxPaid: 0,
      premiumTaxCredit: 0,
      otherCredits: 0,
    };

    creditData &&
      creditData.forEach((credit) => {
        if (!credit.enable || credit.deleted) return;
        const amount = parseFloat(credit.amountOfCredit) || 0;
        switch (credit.taxCredit) {
          case "Child & Dependent Care Credit":
            // Only add if form field is empty to avoid double-counting
            if (credits.careExpenses === 0) {
              credits.careExpenses = Math.max(0, amount / 0.2);
            }
            break;
          case "American Opportunity Credit":
          case "Lifetime Learning Credit":
            // Only add if form field is empty to avoid double-counting
            if (credits.educationExpenses === 0) {
              credits.educationExpenses = amount;
            }
            break;
          case "Adoption Credit":
            credits.adoptionExpenses = Math.min(amount, 17280);
            break;
          case "Earned Income Tax Credit (EITC)":
            credits.numChildren = Math.max(credits.numChildren, 1);
            break;
          case "Saver's Credit":
            // Saver's credit is usually calculated from IRA contributions, 
            // but if explicitly provided in table, we can use it to reverse-calculate contribution if needed.
            // For now, we prioritize the form field 'tradIra'.
            if (credits.contributionAmount === 0) {
              credits.contributionAmount = Math.min(amount / 0.5, 4000);
            }
            break;
          case "Premium Tax Credit":
            credits.premiumTaxCredit += amount;
            break;
          case "Clean Vehicle Credit":
            credits.purchasePrice = amount;
            credits.vehicleType = amount > 4000 ? "new" : "used";
            break;
          case "Energy Efficient Home Improvement Credit":
            credits.improvementCost = Math.min(amount / 0.3, 1200 / 0.3);
            break;
          case "Residential Clean Energy Credit":
            credits.installationCost = amount / 0.3;
            break;
          case "Foreign Tax Credit":
            credits.foreignTaxPaid += amount;
            break;
          case "Other":
            credits.otherCredits += amount;
            break;
          default:
            break;
        }
      });

    const dependents =
      (taxInformationData &&
        taxInformationData["Number of Dependents"] &&
        parseInt(taxInformationData["Number of Dependents"])) ||
      numDependents;

    credits.numDependents = dependents;

    const selectedStateData = stateName
      ? taxData.states.find(
          (s) => s.state.toLowerCase() === stateName.toLowerCase()
        )
      : null;

    if (selectedStateData && selectedStateData.error === true) {
      setResult({
        error: true,
        message: `Tax calculations for ${selectedStateData.state} are not yet supported. We are actively working on it thanks for your patience!`,
        stateNotSupported: selectedStateData.state,
      });
      return;
    }
    // === 6. Final Input Object for calculateTotalTax ===
    const taxInputs = {
      w2Income: Math.max(0, grossIncome - selfIncome),
      seIncome: selfIncome,
      filingStatus,
      state: stateName,
      city,
      hsa,
      studentLoan,
      tradIra: parseFloat(tradIra) || credits.contributionAmount || 0,
      educator,
      dependentCareExp: credits.careExpenses,
      educationExp: credits.educationExpenses,
      dependents,
      deductionType,
      itemizedMedical: itemized.medical || 0,
      itemizedSalt: itemized.salt || 0,
      itemizedMortgage: itemized.mortgage || 0,
      itemizedCharity: itemized.charity || 0,
      netShortTermCG: netShortTerm,
      netLongTermCG: netLongTerm,
      carryforward,
      credits: credits 
    };
    console.log("taxInputs==>", taxInputs);
    // === 7. Calculate Current Year Tax ===
    const currentYearResult = calculateTotalTax(taxInputs);
    console.log("currentYearResult==>", currentYearResult);

    // === 8. Capital Gains Tax breakdown ===
    const cgResult = calculateCapitalGainsTax({
      shortTermGains,
      shortTermLosses,
      longTermGains,
      longTermLosses,
      carryforwardLoss: carryforwardLoss * -1,
      ordinaryIncome: grossIncome,
      filingStatus,
      stateName,
    });

    // === 9. 10-Year Projection ===
    const projectionResult = calculateProjectionSeries({
      ...taxInputs,
      inflation: generalInflationRate,
      years: 10,
    });

    // === 10. Combine & Set Result ===
    setResult({
      ...currentYearResult,
      effectiveRate: currentYearResult.effectiveRate,
      marginalRate: currentYearResult.marginalRate,
      capitalGains: {
        netSTCG: shortTermGains - shortTermLosses,
        netLTCG: longTermGains - longTermLosses,
        carryforwardLoss: carryforwardLoss,
        capitalGainsTax: cgResult.capitalGainsTax,
        deductibleLoss: cgResult.deductibleLoss,
      },
      shortTermGainsLoss: shortTermGains - shortTermLosses,
      longTermGainsLoss: longTermGains - longTermLosses,
      numDependents,
      ...projectionResult,
    });
  }, [taxInformationData, yearlyDataReport, creditData, carryForwardCredits]);

  // console.log("result==>", result,);

  const fields = [
    {
      Component: DropDownTax,
      value: {
        name: "State Taxation",
        title: "State Taxation",
        setSelectedItem: handleTaxInformation,
        list: taxSpecificStatesList,
        displayKey: "name",
        value: taxInformationData && taxInformationData["State Taxation"],
        tooltip: "Tax_State_Taxation",
      },
    },
    {
      Component: DropDownTax,
      value: {
        name: "City of Residence",
        title: "City of Residence",
        setSelectedItem: handleTaxInformation,
        list: cityList,
        displayKey: "name",
        value: taxInformationData && taxInformationData["City of Residence"],
        tooltip: "city_of_residence",
      },
    },
    {
      Component: DropDownTax,
      value: {
        name: "Tax Filling Election",
        title: "Tax Filling Election",
        list: taxFillingElectionList,
        displayKey: "name",
        setSelectedItem: handleTaxInformation,
        value: taxInformationData && taxInformationData["Tax Filling Election"],
        tooltip: "Tax_Tax_Filing_Election",
      },
    },
    {
      Component: DropDownTax,
      value: {
        name: "Deductions",
        title: "Deductions",
        setSelectedItem: handleTaxInformation,
        list: deductionsList,
        displayKey: "name",
        value: taxInformationData && taxInformationData["Deductions"],
        tooltip: "Tax_Deductions",
      },
    },

    {
      Component: IconInputTax,
      value: {
        name: "Effective Tax Rate",
        title: "Effective Tax Rate",
        icon: "%",
        iconPosition: "end",
        value: result && result.effectiveRate ? result.effectiveRate : 0,
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "effective_tax_rate",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Marginal Tax Rate",
        title: "Marginal Tax Rate",
        icon: "%",
        iconPosition: "end",
        value: result && result.marginalRate ? result.marginalRate : 0,
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "marginal_tax_rate",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Total Tax Liability",
        title: "Total Tax Liability",
        icon: "$",
        iconPosition: "start",
        value:
          result && result.totalTaxLiability
            ? parseFloat(result.totalTaxLiability).toFixed(2)
            : 0,
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "total_tax_liability",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Number of Dependents",
        title: "Number of Dependents",
        // icon: "$",
        // iconPosition: "start",
        value: taxInformationData && taxInformationData["Number of Dependents"],
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "number_of_dependents",
      },
    },
  ];
  const itemizedFields = [
    {
      Component: IconInputTax,
      value: {
        name: "Medical and Dental Expenses",
        title: "Medical and Dental Expenses",
        onChange: (event) => handleTaxInformation(event.target),
        icon: "$",
        iconPosition: "start",
        value:
          taxInformationData &&
          taxInformationData["Medical and Dental Expenses"],
        tooltip: "Medical and Dental Expenses",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "State and Local Taxes (SALT)",
        title: "State and Local Taxes (SALT)",
        onChange: (event) => handleTaxInformation(event.target),
        icon: "$",
        iconPosition: "start",
        value:
          taxInformationData &&
          taxInformationData["State and Local Taxes (SALT)"],
        tooltip: "State and Local Taxes (SALT)",
      },
    },

    {
      Component: IconInputTax,
      value: {
        name: "Home Mortgage Interest",
        title: "Home Mortgage Interest",
        icon: "$",
        iconPosition: "start",
        value:
          taxInformationData && taxInformationData["Home Mortgage Interest"],
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "Home Mortgage Interest",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Charitable Contributions",
        title: "Charitable Contributions",
        icon: "$",
        iconPosition: "start",
        value:
          taxInformationData && taxInformationData["Charitable Contributions"],
        onChange: (event) => handleTaxInformation(event.target),
        tooltip: "Charitable Contributions",
      },
    },
  ];
  const formFields = [
    {
      label: "Total Estimated Annual Gross Income",
      type: "number",
      name: "totalYearly",
      tooltip: "total_estimated_annual_gross_income",
    },
  ];
  const formFieldsIncomeAGIAdjustments = [
    {
      label: "W2 Gross Income",
      type: "number",
      name: "grossIncome",
      tooltip: "w2_gross_income",
    },
    {
      label: "Self-Employment Net Earnings",
      type: "number",
      name: "earnedIncome",
      tooltip: "self_employment_net_earnings",
    },
    {
      label: "HSA Contributions",
      type: "number",
      name: "hsaContributions",
      tooltip: "hsa_contributions",
    },
    {
      label: "Student Loan Interest",
      type: "number",
      name: "studentLoan",
      tooltip: "student_loan_interest",
    },
    {
      label: "Traditional IRA Contribution",
      type: "number",
      name: "iraContribution",
      tooltip: "traditional_ira_contribution",
    },
    {
      label: "Educator Expenses",
      type: "number",
      name: "educatorExpenses",
      tooltip: "educator_expenses",
    },
  ];
  const formFieldsCapitalGainsLosses = [
    {
      label: "Net Short-Term Gains / (Loss)",
      type: "number",
      name: "shortTermGainsLoss",
      tooltip: "net_shortterm_gains",
    },
    {
      label: "Net Long-Term Gains / (Loss)",
      type: "number",
      name: "longTermGainsLoss",
      tooltip: "net_longterm_gains",
    },
    {
      label: "Capital Loss Carryforward",
      type: "number",
      name: "lossCarryforward",
      tooltip: "capital_loss_carryforward",
    },
  ];
  const formFieldsFederalTaxCredits = [
    {
      label: "Child & Dependent Care Expenses",
      type: "number",
      name: "careExpenses",
      tooltip: "child_dependent_care",
    },
    {
      label: "Qualified Education Expenses",
      type: "number",
      name: "educationExpenses",
      tooltip: "qualified_education_expenses",
    },
  ];

  return (
    <Style.MainContainer
      style={{
        backgroundColor: "#ffffff",
        margin: "16px",
        position: "relative",
      }}
    >
      <h2
        style={{
          fontSize: "28px",
          fontWeight: "600",
          color: "#2A3DA3",
          margin: "0",
        }}
      >
        Tax Information
      </h2>

      <Style.FieldsContainer>
        {fields &&
          fields.map((data, index) => {
            const { value, Component } = data;
            return (
              <InputGroup key={index} style={{ width: "30%" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {value.title === "numDependents"
                      ? "Number of Dependents"
                      : value.title}
                  </Text>
                  <ToolTipCreator name={value.tooltip} />
                </div>
                <Component key={index} value={value} />
              </InputGroup>
            );
          })}
      </Style.FieldsContainer>
      <div style={{ width: "90%", marginTop: "1rem" }}>
        {taxInformationData &&
          taxInformationData["Deductions"] &&
          taxInformationData["Deductions"] === "Itemized" && (
            <Text
              style={{
                textWrap: "nowrap",
                fontWeight: "500",
                textAlign: "left",
                fontSize: "18px",
              }}
            >
              Itemized Deductions
            </Text>
          )}
      </div>
      <Style.FieldsContainer>
        {taxInformationData &&
          taxInformationData["Deductions"] &&
          taxInformationData["Deductions"] === "Itemized" &&
          itemizedFields &&
          itemizedFields.map((data, index) => {
            const { value, Component } = data;
            return (
              <InputGroup key={index} style={{ width: "30%" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {value.title}
                  </Text>
                  <ToolTipCreator name={value.tooltip} />
                </div>
                <Component key={index} value={value} />
              </InputGroup>
            );
          })}
      </Style.FieldsContainer>
      <div style={{ width: "90%" }}>
        <Collapse
          defaultActiveKey={["Income & AGI Adjustments"]}
          className="custom-collapse-tax"
        >
          <Panel
            header="Income & AGI Adjustments"
            key="Income & AGI Adjustments"
          >
            <SocialSecurityHardCodeFields
              formFields={
                formFieldsIncomeAGIAdjustments && formFieldsIncomeAGIAdjustments
              }
              formData={
                taxInformationData && {
                  ...taxInformationData,
                  // grossIncome: result ? result.grossIncome : 0,
                  grossIncome: yearlyDataReport
                    ? yearlyDataReport.totalYearly
                    : (taxInformationData &&
                        taxInformationData["Gross Income"]) ||
                      result
                    ? result.grossIncome
                    : 0,
                }
              }
              onChange={handleTaxInformationChange}
            />
          </Panel>
        </Collapse>
      </div>
      <div style={{ width: "90%", marginTop: "1rem" }}>
        <Collapse
          defaultActiveKey={["Capital Gains & Losses"]}
          className="custom-collapse-tax"
        >
          <Panel header="Capital Gains & Losses" key="Capital Gains & Losses">
            <SocialSecurityHardCodeFields
              formFields={
                formFieldsCapitalGainsLosses && formFieldsCapitalGainsLosses
              }
              formData={
                taxInformationData && {
                  ...taxInformationData,
                  // shortTermGainsLoss: result ? result.shortTermGainsLoss : 0,
                  // longTermGainsLoss: result ? result.longTermGainsLoss : 0,
                }
              }
              onChange={handleTaxInformationChange}
            />
          </Panel>
        </Collapse>
      </div>
      <div style={{ width: "90%", marginTop: "1rem" }}>
        <Collapse
          defaultActiveKey={["Federal Tax Credits"]}
          className="custom-collapse-tax"
        >
          <Panel header="Federal Tax Credits" key="Federal Tax Credits">
            <SocialSecurityHardCodeFields
              formFields={
                formFieldsFederalTaxCredits && formFieldsFederalTaxCredits
              }
              formData={taxInformationData && taxInformationData}
              onChange={handleTaxInformationChange}
            />
          </Panel>
        </Collapse>
      </div>
      <div style={{ width: "90%" }}>
        <SocialSecurityHardCodeFields
          formFields={formFields && formFields}
          formData={yearlyDataReport && yearlyDataReport}
          onChange={handleInputChangeTax}
        />
        <Button
          style={{ marginTop: "8px" }}
          onClick={() => {
            if (yearlyDataReport) {
              const yearlyData = yearlyDataReport;
              let yearlyResponse = {
                ...yearlyDataReport,
                totalYearly: yearlyData
                  ? (+yearlyData.Active || 0) + (+yearlyData.Passive || 0)
                  : 0,
              };
              setYearlyDataReport(yearlyResponse);
            }
          }}
        >
          {" "}
          Reset
        </Button>
      </div>
      <NewLoader isLoading={loading} />
      <TaxProjectionOverview data={result && result} />
      <Style.ButtonContainer>
        <Button onClick={submitData}>Next</Button>
      </Style.ButtonContainer>
    </Style.MainContainer>
  );
}

export default TaxInformation;
